import { Link } from "react-router-dom";
import { Calculator, Pencil, Mail } from "lucide-react";

const ITEMS = [
  { to: "/simulateur", icon: Calculator, label: "Estimer mes revenus", cls: "bg-[hsl(var(--ocean))] text-white", id: "fab-simulateur" },
  { to: "/devis", icon: Pencil, label: "Demander un devis", cls: "bg-accent text-white", id: "fab-devis" },
  { to: "/contact", icon: Mail, label: "Nous écrire", cls: "bg-[hsl(var(--ocean))] text-white", id: "fab-contact" },
];

export default function FloatingActions() {
  return (
    <div className="fixed right-3 bottom-24 z-40 hidden md:flex flex-col gap-3" data-testid="floating-actions">
      {ITEMS.map((i) => (
        <Link key={i.to} to={i.to} aria-label={i.label} data-testid={i.id}
          className={`group relative w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110 ${i.cls}`}>
          <i.icon size={18} />
          <span className="absolute right-14 whitespace-nowrap bg-primary text-white text-xs font-semibold px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">{i.label}</span>
        </Link>
      ))}
    </div>
  );
}
